import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { PipelineSectionService } from 'src/app/asset-section/pipeline-section/pipeline-section.service';
import { SiteSectionService } from 'src/app/asset-section/site-section/site-section.service';
import { TransmissionLineSectionService } from 'src/app/asset-section/transmission-line-section/transmission-line-section.service';

import { CompanySectionService } from 'src/app/company-section/company-section.service';
import { MessageResponse, MessageType } from 'src/app/components/messages/message-handler/message-handler.component';
import { MessageHandlerFunction, MessageHandlerService } from 'src/app/components/messages/message-handler/message-handler.service';
import { EntityName } from 'src/app/core/models/enumerations/entity-name';
import { PlantSectionService } from 'src/app/plant-section/plant-section.service';
import { StringUtils } from 'src/app/core/utils/string-utils';

import { BoilerSectionService } from 'src/app/boiler-section/boiler-section.service';
import { ProjectsDisplay } from 'src/app/core/models/project/display/projects-display';
import { ProjectSearch } from 'src/app/core/models/search/project-search';
import { DriveSectionService } from 'src/app/drive-section/drive-section.service';
import { EquipmentSectionService } from 'src/app/equipment-section/equipment-section.service';
import { MiningEquipmentSectionService } from 'src/app/mining-equipment-section/mining-equipment-section.service';
import { ProjectSectionService } from 'src/app/project-section/project-section.service';
import { TankSectionService } from 'src/app/tank-section/tank-section.service';
import { UnitSectionService } from 'src/app/unit-section/unit-section.service';
import { AreaSectionService } from '../../../../area-section/area-section.service';
import { WidgetWrapper } from '../../model/widget-wrapper';
import { LockSameUserMessageService } from 'src/app/core/services/lock-same-user-message.service';
import { OfflineEventSectionService } from 'src/app/offline-event-section/offline-event-section.service';
import { FilterSettings } from '../../model/filter-settings';
import { Widget } from '../../model/widget';
import { WidgetService } from '../../widget.service';
import { PlantLtsaSectionService } from 'src/app/ltsa-section/plant-ltsa-section/plant-ltsa-section.service';
import { UnitLtsaSectionService } from 'src/app/ltsa-section/unit-ltsa-section/unit-ltsa-section.service';
import { PipelineLtsaSectionService } from 'src/app/ltsa-section/pipeline-ltsa-section/pipeline-ltsa-section.service';
import { TelemetryService } from 'src/app/core/services/telemetry.service';

@Component({
    selector: 'app-quick-access',
    standalone: false,
    templateUrl: './quick-access.component.html',
    styleUrls: ['./quick-access.component.scss'],
    providers: [FormBuilder]
})
export class QuickAccessComponent implements OnInit {
    @ViewChild('inputCompanyId', { static: false }) inputCompanyId?: ElementRef;
    @ViewChild('inputSiteId', { static: false }) inputSiteId?: ElementRef;
    @ViewChild('inputTankId', { static: false }) inputTankId?: ElementRef;
    @ViewChild('inputAreaId', { static: false }) inputAreaId?: ElementRef;
    @ViewChild('inputPipelineId', { static: false }) inputPipelineId?: ElementRef;
    @ViewChild('inputTlineId', { static: false }) inputTlineId?: ElementRef;
    @ViewChild('inputPlantId', { static: false }) inputPlantId?: ElementRef;
    @ViewChild('inputUnconfirmedProjectId', { static: false }) inputUnconfirmedProjectId?: ElementRef;
    @ViewChild('inputConfirmedProjectId', { static: false }) inputConfirmedProjectId?: ElementRef;
    @ViewChild('inputDriveId', { static: false }) inputDriveId?: ElementRef;
    @ViewChild('inputEquipmentId', { static: false }) inputEquipmentId?: ElementRef;
    @ViewChild('inputMEquipmentId', { static: false }) inputMEquipmentId?: ElementRef;
    @ViewChild('inputUnitId', { static: false }) inputUnitId?: ElementRef;
    @ViewChild('inputBoilerId', { static: false }) inputBoilerId?: ElementRef;
    @ViewChild('inputOfflineEventId', { static: false }) inputOfflineEventId?: ElementRef;
    @ViewChild('inputPlantLtsaId', { static: false }) inputPlantLtsaId?: ElementRef;
    @ViewChild('inputUnitLtsaId', { static: false }) inputUnitLtsaId?: ElementRef;
    @ViewChild('inputPipelineLtsaId', { static: false }) inputPipelineLtsaId?: ElementRef;
    
    companyID!: string;
    siteID!: string;
    pipelineID!: string;
    tLineID!: string;
    plantID!: string;
    areaID!: string;
    unitID!: string;
    boilerID!: string;
    driveID!: string;
    equipmentID!: string;
    tankID!: string;
    mEquipmentID!: string;
    offlineEventID!: string;
    confirmedProjectID!: string;
    unconfirmedProjectID!: string;
    plantLtsaID!: string;
    unitLtsaID!: string;
    pipelineLtsaID!: string;
    
    visibleEntities: Array<EntityName> = [];
    
    public widgetWrapper!: WidgetWrapper;
    
    public filterSettings!: FilterSettings;

    constructor(
        private readonly widgetService: WidgetService,
        private readonly messageService: MessageHandlerService,
        private readonly translate: TranslateService,
        private readonly telemetry: TelemetryService,
        private readonly companySectionService: CompanySectionService,
        private readonly areaService: AreaSectionService,
        private readonly plantLtsaService: PlantLtsaSectionService,
        private readonly unitLtsaService: UnitLtsaSectionService,
        private readonly pipelineLtsaService: PipelineLtsaSectionService,
        private readonly siteService: SiteSectionService,
        private readonly tankService: TankSectionService,
        private readonly pipelineService: PipelineSectionService,
        private readonly tLineService: TransmissionLineSectionService,
        private readonly plantService: PlantSectionService,
        private readonly projectService: ProjectSectionService,
        private readonly driveService: DriveSectionService,
        private readonly equipmentService: EquipmentSectionService,
        private readonly miningEquipmentService: MiningEquipmentSectionService,
        private readonly unitService: UnitSectionService,
        private readonly lockSameUserMessageService: LockSameUserMessageService,
        private readonly boilerService: BoilerSectionService,
        private readonly offlineEventService: OfflineEventSectionService
    ) { }

    ngOnInit() {
        
        this.tankID = '';
        this.companyID = '';
        this.siteID = '';
        this.pipelineID = '';
        this.tLineID = '';
        this.plantID = '';
        this.areaID = '';
        this.unitID = '';
        this.boilerID = '';
        this.driveID = '';
        this.tankID = '';
        this.mEquipmentID = '';
        this.equipmentID = '';
        this.offlineEventID = '';
        this.confirmedProjectID = '';
        this.unconfirmedProjectID = '';
        this.boilerID = '';
        this.plantLtsaID = '';
        this.unitLtsaID = '';
        this.pipelineLtsaID = '';
       
        this.filterSettings = {
            itemCount: String(this.widgetWrapper.widgetData.itemCount),
            entityType: this.widgetWrapper.widgetData.entitiesFilter ? this.widgetWrapper.widgetData.entitiesFilter : [],
            fiterEntities: Widget.getEntitySettings().map(x => ({ ...x}))
        }
        this.filterSettings.fiterEntities.forEach(ent => {
            if (this.filterSettings.entityType.includes(ent.id)) {
                ent.checked = true;
            } else {
                ent.checked = false;
            }
        });

        this.setVisibleItems();        
    }
    
    private setVisibleItems(): void {
        const entitiesFilter = this.filterSettings.entityType;
        const accessibleEntities = this.widgetService.getAccessibleEntities();
        this.visibleEntities = entitiesFilter.length > 0 ? accessibleEntities.filter(e => entitiesFilter.includes(e)) : accessibleEntities;
    }


    public updateData(): void {
        this.setVisibleItems();
    }
    public saveSettings(): void {
        this.filterSettings.entityType = this.filterSettings.fiterEntities
            .filter(ent => ent.checked)
            .map(ent => ent.id);
        this.widgetService.saveWidget(this, this.filterSettings, this.widgetWrapper);
        this.widgetWrapper.showProperties = false;
    };

    private openRecord(path: string, entityID: string, entityName: string): void {
        const target: string = entityName + entityID;
        this.lockSameUserMessageService.validateEntityIsLockedByUserAndOpenEntityTab(entityName, entityID, location.pathname + `#/ED/${path}/${entityID}`, `${target}`);
        this.telemetry.featureUsage("quickAccess");
    }

    private static sanitizeID(unsafe: string): string
    {
       return unsafe?.replaceAll(/\D/g,'');
    };

    /**
     * This will choose a pasted value, or fall back to a manually entered value, but in either case it will be a sanitized value
     */
    private static getIdValue(event: ClipboardEvent | undefined, idValue: string): string
    {
        if(event?.type === "paste")
        {
            event.preventDefault();           
            idValue = event.clipboardData?.getData('text') ?? '';
        }
        return QuickAccessComponent.sanitizeID(idValue);
    }

    /**
     * NOTE: This keeps the visible value clean, however it does not actually clean the model data.
     *       As such, the goToXYZ functions must still perform a sanitize before taking action. 
     */ 
    cleanID(event: Event)
    {    
        let elem = (<HTMLInputElement>(event.target));
        let value = elem.value;
        let sanitized = QuickAccessComponent.sanitizeID(elem.value);
        if(value !== sanitized)
        {
            elem.value = sanitized;
        }
    }

    goToCompany(event?: ClipboardEvent) {
        this.companyID = QuickAccessComponent.getIdValue(event, this.companyID);
        if (this.companyID !== '') {
            this.companySectionService.getCompanyById(Number(this.companyID))
                .subscribe({next: () => {
                    this.openRecord('company', this.companyID, EntityName.COMPANY);
                    this.companyID = '';
                },
                error: (error: any) => {
                    const confirmOk = (resp: MessageResponse): void => {
                        this.companyID = '';
                        this.inputCompanyId!.nativeElement.focus();
                    };
                    this.messageService.show(this.translate.instant('widgets.quickAccess.entityNotExists', { entity: EntityName.COMPANY }), MessageType.INFO, confirmOk);
                }
            });
        }
    }

    goToArea(event?: ClipboardEvent) {
        this.areaID = QuickAccessComponent.getIdValue(event, this.areaID);
        if (this.areaID !== '') {
            this.areaService.getAreaById(Number(this.areaID))
                .subscribe({next: () => {
                    this.openRecord('area', this.areaID, EntityName.AREA);
                    this.areaID = '';
                },
                error: (error: any) => {
                    const confirmOk = (resp: MessageResponse): void => {
                        this.areaID = '';
                        this.inputAreaId!.nativeElement.focus();
                    };
                    this.messageService.show(this.translate.instant('widgets.quickAccess.entityNotExists', { entity: EntityName.AREA }), MessageType.INFO, confirmOk);
                }
            });
        }
    }

    goToSite(event?: ClipboardEvent) {
        this.siteID = QuickAccessComponent.getIdValue(event, this.siteID);
        if (this.siteID !== '') {
            this.siteService.getSiteById(Number(this.siteID))
                .subscribe({next: () => {
                    this.openRecord('site', this.siteID, EntityName.SITE);
                    this.siteID = '';
                },
                error: (error: any) => {
                    const confirmOk = (resp: MessageResponse): void => {
                        this.siteID = '';
                        this.inputSiteId!.nativeElement.focus();
                    };
                    this.messageService.show(this.translate.instant('widgets.quickAccess.entityNotExists', { entity: EntityName.SITE }), MessageType.INFO, confirmOk);
                }
            });
        }
    }

    goToTank(event?: ClipboardEvent) {
        this.tankID = QuickAccessComponent.getIdValue(event, this.tankID);
        if (this.tankID !== '') {
            this.tankService.getTankById(Number(this.tankID))
                .subscribe({next: () => {
                    this.openRecord('tank', this.tankID, EntityName.TANK);
                    this.tankID = '';
                },
                error: (error: any) => {
                    const confirmOk = (resp: MessageResponse): void => {
                        this.tankID = '';
                        this.inputTankId!.nativeElement.focus();
                    };
                    this.messageService.show(this.translate.instant('widgets.quickAccess.entityNotExists', { entity: EntityName.TANK }), MessageType.INFO, confirmOk);
                }
            });
        }
    }

    goToDrive(event?: ClipboardEvent) {
        this.driveID = QuickAccessComponent.getIdValue(event, this.driveID);
        if (this.driveID !== '') {
            this.driveService.getDriveById(Number(this.driveID))
                .subscribe({next: () => {
                    this.openRecord('drive', this.driveID, EntityName.TURBINE);
                    this.driveID = '';
                },
                error: (error: any) => {
                    const confirmOk = (resp: MessageResponse): void => {
                        this.driveID = '';
                        this.inputDriveId!.nativeElement.focus();
                    };
                    this.messageService.show(this.translate.instant('widgets.quickAccess.entityNotExists', { entity: EntityName.TURBINE }), MessageType.INFO, confirmOk);
                }
            });
        }
    }

    goToEquipment(event?: ClipboardEvent) {
        this.equipmentID = QuickAccessComponent.getIdValue(event, this.equipmentID);
        if (this.equipmentID !== '') {
            this.equipmentService.getEquipmentById(Number(this.equipmentID))
                .subscribe({next: () => {
                    this.openRecord('otherEquipment', this.equipmentID, EntityName.OEQUIPMENT);
                    this.equipmentID = '';
                },
                error: (error: any) => {
                    const confirmOk = (resp: MessageResponse): void => {
                        this.equipmentID = '';
                        this.inputEquipmentId!.nativeElement.focus();
                    };
                    this.messageService.show(this.translate.instant('widgets.quickAccess.entityNotExists', { entity: EntityName.OEQUIPMENT }), MessageType.INFO, confirmOk);
                }
            });
        }
    }

    goToMEquipment(event?: ClipboardEvent) {
        this.mEquipmentID = QuickAccessComponent.getIdValue(event, this.mEquipmentID);
        if (this.mEquipmentID !== '') {
            this.miningEquipmentService.getMiningEquipmentById(Number(this.mEquipmentID))
                .subscribe({next: () => {
                    this.openRecord('miningEquipment', this.mEquipmentID, EntityName.MEQUIPMENT);
                    this.mEquipmentID = '';
                },
                error: (error: any) => {
                    const confirmOk = (resp: MessageResponse): void => {
                        this.mEquipmentID = '';
                        this.inputMEquipmentId!.nativeElement.focus();
                    };
                    this.messageService.show(this.translate.instant('widgets.quickAccess.entityNotExists', { entity: EntityName.MEQUIPMENT }), MessageType.INFO, confirmOk);
                }
            });
        }
    }

    goToPipeline(event?: ClipboardEvent) {
        this.pipelineID = QuickAccessComponent.getIdValue(event, this.pipelineID);
        if (this.pipelineID !== '') {
            this.pipelineService.getPipelineById(Number(this.pipelineID))
                .subscribe({next: () => {
                    this.openRecord('pipeline', this.pipelineID, EntityName.ASSET_PIPELINE);
                    this.pipelineID = '';
                },
                error: (error: any) => {
                    const confirmOk = (resp: MessageResponse): void => {
                        this.pipelineID = '';
                        this.inputPipelineId!.nativeElement.focus();
                    };
                    this.messageService.show(this.translate.instant('widgets.quickAccess.entityNotExists', { entity: EntityName.ASSET_PIPELINE }), MessageType.INFO, confirmOk);
                }
            });
        }
    }

    goToTLine(event?: ClipboardEvent) {
        this.tLineID = QuickAccessComponent.getIdValue(event, this.tLineID);
        if (this.tLineID !== '') {
            this.tLineService.getTransmissionLineById(Number(this.tLineID))
                .subscribe({next: () => {
                    this.openRecord('transmissionLine', this.tLineID, EntityName.ASSET_TRANSMISSION_LINE);
                    this.tLineID = '';
                },
                error: (error: any) => {
                    const confirmOk = (resp: MessageResponse): void => {
                        this.tLineID = '';
                        this.inputTlineId!.nativeElement.focus();
                    };
                    this.messageService.show(this.translate.instant('widgets.quickAccess.entityNotExists', { entity: EntityName.ASSET_TRANSMISSION_LINE }), MessageType.INFO, confirmOk);
                }
            });
        }
    }

    goToPlant(event?: ClipboardEvent) {
        this.plantID = QuickAccessComponent.getIdValue(event, this.plantID);
        if (this.plantID !== '') {
            this.plantService.getPlantById(Number(this.plantID))
                .subscribe({next: () => {
                    this.openRecord('plant', this.plantID, EntityName.PLANT);
                    this.plantID = '';
                },
                error: (error: any) => {
                   const confirmOk = (resp: MessageResponse): void => {
                       this.plantID = '';
                       this.inputPlantId!.nativeElement.focus();
                   };
                    this.messageService.show(this.translate.instant('widgets.quickAccess.entityNotExists', { entity: EntityName.PLANT }), MessageType.INFO, confirmOk);

                }
            });
        }
    }

    goToConfirmedProject(event?: ClipboardEvent) {
        this.confirmedProjectID = QuickAccessComponent.getIdValue(event, this.confirmedProjectID);
        this.goToProject(this.confirmedProjectID, EntityName.PROJECT_CONFIRMED);
    }

    goToUnconfirmedProject(event?: ClipboardEvent) {
        this.unconfirmedProjectID = QuickAccessComponent.getIdValue(event, this.unconfirmedProjectID);
        this.goToProject(this.unconfirmedProjectID, EntityName.PROJECT_UNCONFIRMED);
    }

    private clearProjectId(projectType: string): void{
        if(projectType === EntityName.PROJECT_CONFIRMED) {
            this.confirmedProjectID = '';
        } else if(projectType === EntityName.PROJECT_UNCONFIRMED) {
            this.unconfirmedProjectID = ''
        }
    }

    private goToProject(projectID: string, projectType: string) {
        if ((this.confirmedProjectID !== '' && projectType === EntityName.PROJECT_CONFIRMED) || (this.unconfirmedProjectID !== '' && projectType === EntityName.PROJECT_UNCONFIRMED)) {
            let confirmOk:MessageHandlerFunction;
            if(projectType === EntityName.PROJECT_CONFIRMED){
                confirmOk = (resp: MessageResponse): void => {
                    this.confirmedProjectID = '';
                    this.inputConfirmedProjectId!.nativeElement.focus();
                };
            }else{
                confirmOk = (resp: MessageResponse): void => {
                    this.unconfirmedProjectID = '';
                    this.inputUnconfirmedProjectId!.nativeElement.focus();
                };
            }
            this.projectService.getProjectById(Number(projectID))
                .subscribe({next:(project: ProjectSearch | null) => {
                        if(project === null){
                            this.messageService.show(this.translate.instant('widgets.quickAccess.entityNotExists', { entity: projectType }), MessageType.INFO, confirmOk);
                        }else if(projectType === EntityName.PROJECT_UNCONFIRMED && !ProjectsDisplay.isUnconfirmed(project.projectStatusId, project.projectRecordStatus) && !StringUtils.isEmpty(project.qcDate)){
                            this.messageService.show(this.translate.instant('widgets.quickAccess.invalidUncProjectScreen'), MessageType.INFO, confirmOk);
                        }else{
                            this.openRecord(projectType === EntityName.PROJECT_CONFIRMED ? 'confirmedProject' : 'unconfirmedProject', projectID, projectType);
                        }
                        this.clearProjectId(projectType);
                    },
                    error:(error: any) => {
                        this.messageService.show(this.translate.instant('widgets.quickAccess.entityNotExists', { entity: projectType }), MessageType.INFO, confirmOk);
                        this.clearProjectId(projectType);
                    }
            });
        }
    }

    goToUnit(event?: ClipboardEvent) {
        this.unitID = QuickAccessComponent.getIdValue(event, this.unitID);
        if (this.unitID !== '') {
            this.unitService.getUnitById(Number(this.unitID))
                .subscribe({next: () => {
                    this.openRecord('unit', this.unitID, EntityName.UNIT);
                    this.unitID = '';
                },
                error: (error: any) => {
                    const confirmOk = (resp: MessageResponse): void => {
                        this.unitID = '';
                        this.inputUnitId!.nativeElement.focus();
                    };
                    this.messageService.show(this.translate.instant('widgets.quickAccess.entityNotExists', { entity: EntityName.UNIT }), MessageType.INFO, confirmOk);
                }
            });
        }
    }

    goToBoiler(event?: ClipboardEvent) {
        this.boilerID = QuickAccessComponent.getIdValue(event, this.boilerID);
        if (this.boilerID !== '') {
            this.boilerService.getBoilerById(Number(this.boilerID))
                .subscribe({next: () => {
                    this.openRecord('boiler', this.boilerID, EntityName.BOILER);
                    this.boilerID = '';
                },
                error: (error: any) => {
                    const confirmOk = (resp: MessageResponse): void => {
                        this.boilerID = '';
                        this.inputBoilerId!.nativeElement.focus();
                    };
                    this.messageService.show(this.translate.instant('widgets.quickAccess.entityNotExists', { entity: EntityName.BOILER }), MessageType.INFO, confirmOk);
                }
            });
        }
    }

    goToOfflineEvent(event?: ClipboardEvent) {
        this.offlineEventID = QuickAccessComponent.getIdValue(event, this.offlineEventID);
        if (this.offlineEventID !== '') {
            this.offlineEventService.getOfflineEventById(Number(this.offlineEventID))
                .subscribe({next: () => {
                    this.openRecord('offlineEvent', this.offlineEventID, EntityName.OFFLINE_EVENT);
                    this.offlineEventID = '';
                },
                error: (error: any) => {
                    const confirmOk = (resp: MessageResponse): void => {
                        this.offlineEventID = '';
                        this.inputOfflineEventId!.nativeElement.focus();
                    };
                    this.messageService.show(this.translate.instant('widgets.quickAccess.entityNotExists', { entity: EntityName.OFFLINE_EVENT }), MessageType.INFO, confirmOk);
                }
            });
        }
    }

    public goToPlantLtsa(event?: ClipboardEvent) {
        this.plantLtsaID = QuickAccessComponent.getIdValue(event, this.plantLtsaID);
        if (this.plantLtsaID !== '') {
            this.plantLtsaService.getLtsaById(Number(this.plantLtsaID))
                .subscribe({next: () => {
                    this.openRecord('plantLtsa', this.plantLtsaID, EntityName.PLANT_LTSA);
                    this.plantLtsaID = '';
                },
                error: (error: any) => {
                    const confirmOk = (resp: MessageResponse): void => {
                        this.plantLtsaID = '';
                        this.inputPlantLtsaId!.nativeElement.focus();
                    };
                    this.messageService.show(this.translate.instant('widgets.quickAccess.entityNotExists', { entity: EntityName.PLANT_LTSA }), MessageType.INFO, confirmOk);
                }
            });
        }
    }

    public goToUnitLtsa(event?: ClipboardEvent) {
        this.unitLtsaID = QuickAccessComponent.getIdValue(event, this.unitLtsaID);
        if (this.unitLtsaID !== '') {
            this.unitLtsaService.getLtsaById(Number(this.unitLtsaID))
                .subscribe({next: () => {
                    this.openRecord('unitLtsa', this.unitLtsaID, EntityName.UNIT_LTSA);
                    this.unitLtsaID = '';
                },
                error: (error: any) => {
                    const confirmOk = (resp: MessageResponse): void => {
                        this.unitLtsaID = '';
                        this.inputUnitLtsaId!.nativeElement.focus();
                    };
                    this.messageService.show(this.translate.instant('widgets.quickAccess.entityNotExists', { entity: EntityName.UNIT_LTSA }), MessageType.INFO, confirmOk);
                }
            });
        }
    }

    public goToPipelineLtsa(event?: ClipboardEvent) {
        this.pipelineLtsaID = QuickAccessComponent.getIdValue(event, this.pipelineLtsaID);
        if (this.pipelineLtsaID !== '') {
            this.pipelineLtsaService.getLtsaById(Number(this.pipelineLtsaID))
                .subscribe({next: () => {
                    this.openRecord('pipelineLtsa', this.pipelineLtsaID, EntityName.PIPELINE_LTSA);
                    this.pipelineLtsaID = '';
                },
                error: (error: any) => {
                    const confirmOk = (resp: MessageResponse): void => {
                        this.pipelineLtsaID = '';
                        this.inputPipelineLtsaId!.nativeElement.focus();
                    };
                    this.messageService.show(this.translate.instant('widgets.quickAccess.entityNotExists', { entity: EntityName.PIPELINE_LTSA }), MessageType.INFO, confirmOk);
                }
            });
        }
    }

    // This exposes the enum to the template
    public get entityName(): typeof EntityName {
        return EntityName;
    }
}
